export const clients = {
  addressType: {
    'establishment unit': 'Unité d’établissement',
    headquarters: 'Siège social',
  },
  alerts: {
    errorKboInformation: 'Une erreur s’est produite lors de la récupération des données de l’entreprise. Veuillez réessayer plus tard.',
    errorViesInformation: 'Une erreur s’est produite lors de la récupération des données de l’entreprise. Veuillez réessayer plus tard.',
    successContactCreated: 'Votre personne de contact a été créée.',
    successContactDeleted: 'Votre personne de contact a été supprimée.',
    successContactEditedOrganisation: 'Votre personne de contact a été modifiée.',
    successContactEditedPrivate: 'Votre client a été modifié.',
    successCreated: 'Votre client a été créé.',
    successDeleted: 'Votre client a été supprimé.',
    successUpdated: 'Votre client a été modifié.',
  },
  breadcrumb: {
    create: 'Nouveau client',
    createContact: 'Nouvelle personne de contact',
    edit: 'Modifier le client',
    editContact: 'Modifier la personne de contact',
    overview: 'Clients',
    show: 'Détails du client',
  },
  card: {
    address: 'Adresse',
    label: 'Client',
  },
  contact: 'Personne de contact',
  create: {
    blocker: 'Voulez-vous vraiment quitter cette page ? Votre client n’a pas été enregistré.',
    chooseType: {
      organisation: {
        description: 'Ajoutez une organisation avec une personne de contact',
        title: 'Organisation',
      },
      private: {
        description: 'Ajoutez un client particulier ou une association de fait',
        title: 'Particulier',
      },
      title: 'Choisissez le type de client',
    },
    company: {
      changeVatNumber: 'Ce n’est pas ce que vous cherchez ? Saisissez un autre numéro de TVA.',
      companyInformationDisclaimer:
        'Nous avons trouvé ces données sur la base du numéro de TVA. Vous pourrez ajouter des données (personnelles) supplémentaires à l’étape suivante.',
      companyInformationDisclaimerWithoutAddress:
        'Nous avons trouvé l’organisation ci-dessus sur la base du numéro de TVA. L’adresse du siège social est encore manquante. Pouvez-vous la compléter ou la demander à votre client ?',
      hasVatNumberLink: 'Numéro de TVA ?',
      noVatNumberLink: 'Pas de numéro de TVA ?',
      searchCompanyInformation: 'Rechercher',
      switchToOtherNumber: 'Votre client n’a pas de numéro de TVA ? <0>Cliquez ici pour saisir un autre numéro.</0>',
      switchToVatNumber: 'Votre client a un numéro de TVA ? <0>Cliquez ici pour rechercher par numéro de TVA.</0>',
    },
    next: 'Suivant',
    previous: 'Précédent',
    save: 'Enregistrer',
    submit: 'Créer le client',
    title: 'Nouveau client',
    type: {
      contact: 'Personne de contact',
      organisation: 'Organisation',
    },
  },
  createContact: {
    blocker: 'Voulez-vous vraiment quitter cette page ? Votre personne de contact n’a pas été enregistrée.',
    submit: 'Ajouter une personne de contact',
  },
  createEdit: {
    subsections: {
      comments: {
        description: 'Prenez ici des notes sur ce client, par exemple sur un délai de paiement différent, des accords particuliers, …',
        fieldFootnote: 'Visible uniquement par vous.',
        fieldLabel: 'Notes',
        title: 'Notes',
      },
      contactAddress: 'Adresse',
      customAgreement: {
        description:
          'Avez-vous avec votre client un contrat-cadre existant d’une durée de plus de 6 mois ? Cochez la case. Plus d’infos et pourquoi c’est important pour nous ? <a href="https://knowledge.creativeshelter.be/opdrachtgevers-en-overeenkomsten-wij-zetten-je-op-weg" target="_blank">Lisez-le ici.</a>',
        title: 'Contrat-cadre',
      },
      emails: {
        description: 'Choisissez qui reçoit quelle communication, ou recevez-la vous-même.',
        title: 'E-mails',
      },
      personalInfo: 'Données personnelles',
    },
  },
  customAgreementDialog: {
    cancel: 'Non, revenir en arrière',
    description:
      'Ne confirmez que si vous avez déjà un contrat signé avec ce client. Nous vous enverrons ensuite un e-mail pour relire le contrat. Pourquoi ? Nous devons en effet nous joindre au contrat. Plus d’infos ? Lisez-les <a href="https://knowledge.creativeshelter.be/opdrachtgevers-en-overeenkomsten-wij-zetten-je-op-weg" target="_blank">ici</a>.',
    submit: 'Oui, j’ai un contrat signé',
    title: 'Attention !',
  },
  detail: {
    contacts: {
      add: 'Ajouter une personne de contact',
      columns: {
        email: 'Adresse e-mail',
        name: 'Nom',
        phoneNumber: 'Numéro de téléphone',
      },
      delete: {
        description: 'Voulez-vous vraiment supprimer la personne de contact « {{name}} » ?',
        submit: 'Supprimer la personne de contact',
        title: 'Supprimer la personne de contact',
      },
      moreEmails: 'Et {{amount}} autre(s)',
      rowActions: {
        duplicate: 'Copier',
      },
      selfEmail: '{{email}} (vous-même)',
      title: 'Personnes de contact ({{amount}})',
    },
    info: {
      creditsafe: {
        creditRating: {
          label: 'Solvabilité',
          tooltip:
            'Ce score donne un aperçu des finances de votre client.\n<faqLink href="https://knowledge.creativeshelter.be/creditsafe-wat-zegt-dat-precies-over-je-opdrachtgever">Pour en savoir plus, lisez ceci.</faqLink>',
        },
        score: {
          '?': {
            text: 'Aucune information',
          },
          A: {
            text: 'Risque très faible',
          },
          B: {
            text: 'Risque faible',
          },
          C: {
            text: 'Risque moyen',
          },
          D: {
            text: 'Risque plus élevé',
          },
        },
        status: {
          Error: 'Le score de crédit n’a pas pu être récupéré.',
          NotFetched: 'Le score de crédit est en cours de récupération.',
        },
      },
      edit: {
        action: 'Modifier l’organisation',
      },
      refreshVatInformation: {
        ariaLabel: 'Récupérer à nouveau les données de l’entreprise',
        lastUpdated: 'Mis à jour depuis la BCE {{timeAgo}}',
        tooltip: {
          notRefreshable:
            'Récupérez les données les plus récentes de votre client auprès de la <kboLink>Banque-Carrefour des Entreprises</kboLink>.<br/>(Ce n’est possible que si les données datent de plus de 7 jours.)',
          refreshable:
            'Récupérez les données les plus récentes de votre client auprès de la <kboLink>Banque-Carrefour des Entreprises</kboLink>.',
        },
      },
    },
    invoices: {
      title: 'Factures',
      titleWithCount: 'Factures ({{amount}})',
    },
  },
  editClient: {
    blocker: 'Voulez-vous vraiment quitter cette page ? Les modifications apportées à votre client n’ont pas été enregistrées.',
  },
  editContact: {
    blocker:
      'Voulez-vous vraiment quitter cette page ? Les modifications apportées à votre personne de contact n’ont pas été enregistrées.',
  },
  fields: {
    address: {
      label: 'Adresse',
    },
    city: {
      label: 'Commune',
    },
    companyName: {
      label: 'Nom de l’entreprise',
    },
    countryCode: {
      groups: {
        europe: 'Europe',
        europeanUnion: 'Union européenne',
        international: 'International',
      },
      label: 'Pays',
      placeholder: 'Sélectionnez un pays',
    },
    customAgreement: {
      label: 'J’ai un contrat-cadre existant avec ce client.',
      tooltip: 'Les accords de moins de 6 mois ou les accords ponctuels ne sont pas concernés.',
    },
    emailAddresses: {
      addReceiver: 'Ajouter un destinataire supplémentaire',
      addSelf: 'Envoyer moi-même',
      invoicesAndCreditNotes: 'Factures et notes de crédit',
      label: 'Adresse e-mail',
      paymentReminders: 'Rappels de paiement',
      peppolDisclaimer:
        'Votre client reçoit les factures et les notes de crédit via Peppol. Nous l’informons par e-mail que le document se trouve dans sa boîte de réception Peppol.',
      placeholder: 'Saisissez l’adresse e-mail',
      quotations: 'Devis',
    },
    enterpriseNumber: {
      label: 'Numéro de TVA ou d’entreprise',
    },
    firstName: {
      label: 'Prénom',
      placeholder: 'Prénom',
    },
    function: {
      label: 'Fonction',
      placeholder: 'Fonction',
    },
    lang: {
      label: 'Langue',
    },
    lastName: {
      label: 'Nom de famille',
      placeholder: 'Nom de famille',
    },
    number: {
      label: 'Numéro',
    },
    organisationName: {
      add: 'Association de fait',
      label: 'Nom de l’organisation',
      tooltip: 'Votre client est une association de fait ? Saisissez ici le nom de l’association.',
    },
    otherNumber: {
      label: 'Autre numéro',
      placeholder: 'Autre numéro',
    },
    street: {
      label: 'Rue',
    },
    telephone: {
      label: 'Numéro de téléphone',
      placeholder: 'Numéro de téléphone',
    },
    useOrganisationAddress: {
      label: 'Utiliser l’adresse de l’organisation',
    },
    userComments: {
      placeholder: 'Remarque ou rappel pour vous-même',
    },
    vatNumber: {
      label: 'Numéro de TVA',
    },
    vatOrOtherNumber: {
      label: 'Numéro de TVA ou autre numéro',
    },
    zipcode: {
      label: 'Code postal',
    },
  },
  header: {
    actionBlock: {
      button: 'Créer un client',
    },
    title: 'Clients',
  },
  overview: {
    columns: {
      contacts: 'Personnes de contact',
      name: 'Nom',
      type: 'Type de client',
      vatOrOtherNumber: 'Numéro de TVA ou autre numéro',
    },
    delete: {
      description: 'Voulez-vous vraiment supprimer « {{name}} » ?',
      submit: 'Supprimer le client',
      title: 'Supprimer le client',
    },
    moreContacts: 'Et {{amount}} autre(s)',
    rowActions: {
      addContact: 'Ajouter une personne de contact',
      view: 'Consulter',
    },
    vat: {
      mailTooltip: 'Cette entreprise n’est pas encore connectée au réseau Peppol. Nous envoyons donc la facture par e-mail.',
      peppolTooltip: 'Cette entreprise est connectée au réseau Peppol. Les factures et les notes de crédit sont envoyées via Peppol.',
    },
  },
  peppol: {
    status: {
      active: 'Actif',
      error: 'Nous n’avons pas pu récupérer l’identifiant Peppol de votre client.',
      label: 'Peppol',
      notRegistered: 'Pas encore inscrit sur Peppol',
      pending: 'Récupération de l’identifiant Peppol…',
      tooltip: {
        active:
          "Votre client est actif sur Peppol ? Les factures et les notes de crédit sont alors envoyées automatiquement via le réseau Peppol. Lisez-en <faqLink href='https://www.creativeshelter.be/knowledge-hub/sturen-jullie-facturen-via-peppol-mercuriusplatform-e-invoicing'>tout ici</faqLink>.",
        notRegistered: 'Votre client n’est pas encore inscrit sur Peppol. Nous envoyons donc les factures par e-mail pour l’instant.',
      },
    },
  },
  type: {
    organisation: 'Organisation',
    private: 'Particulier',
  },
};
